<p class="recaptcha">
  ユーザーがロボットではないことを確認するため、このページは Google reCAPTCHA を使用しています。
  <br />
  Google reCAPTCHAにより収集される情報は、Googleの
  <a href="https://policies.google.com/privacy">プライバシーポリシー</a>
  および
  <a href="https://policies.google.com/terms">利用規約</a>
  の対象となります。
</p>
